import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const ConcelloInventarioTotalSection = ({concello}) => {
    return (
        <SectionCard title="Total">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Lonxitude rede:"
                        value={NumberUtil.formatDecimal(
                            concello.stats.lonxitudetotalcolector,
                            3
                        )}
                        unit="Km."
                        tooltipText="Lonxitude dixitalizada da rede (considerando só as conduccións de natureza fecal ou unitaria)"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default ConcelloInventarioTotalSection;
